exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-drawer {\n  overflow-y: scroll;\n}\n.el-badge__content.is-fixed {\n  top: 10px;\n}\n.el-badge__content {\n  border: none;\n}\na.el-link, span.el-link--inner {\n  width: 100%!important;\n}\n", ""]);

// exports
